import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button } from '../../../components/base';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { PERSONAL_EMPLOYEE_CONTRACT_TABLE_FIELDS } from '../../../constants/personnel.constant';

export default class EmployeeContract extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/personalia/surat/tambah-karyawan-kontrak');
  }

  render() {
    const { handleGetEmployeeContract } = this.props;
    return (
      <div className="employee-contract">
        <Button
          title="Tambah Surat Kontrak Karyawan"
          onClick={this.onClickAdd}
        />
        <div className="employee-contract__content">
          <ContentTable
            onSearchContent={handleGetEmployeeContract}
            tableFields={PERSONAL_EMPLOYEE_CONTRACT_TABLE_FIELDS}
          />
        </div>
      </div>
    );
  }
}
EmployeeContract.propTypes = {
  handleGetEmployeeContract: PropTypes.func,
  history: PropTypes.object.isRequired,
};
EmployeeContract.defaultProps = {
  handleGetEmployeeContract: noop,
};
